import { useState } from "react";
import { Card, Row, Col, Button } from "react-bootstrap";

import Template_Generic from "../../Assets/Images/html5-templates/Template_Generic.png"
import Template_Ecommerce_Carousel from "../../Assets/Images/html5-templates/Template_Ecommerce_Carousel.png"
import Template_Akedo_Packshot from "../../Assets/Images/html5-templates/Template_Akedo_Packshot.png"
import Template_Akedo_Game from "../../Assets/Images/html5-templates/Template_Akedo_Game.png"

import TemplateDesignForm from "./TemplateDesignForm";

const Html5Generator = () => {
    const [templateType,setTemplateType] = useState('');
    const [screenType,setScreenType] = useState('template_selection');
    const [templateFields,setTemplateFields] = useState<any>([]);

    const handleTemplateSelectionChange = (template:string)=>{
        setTemplateType(template);
        setTemplateFields([]);
        if(template==='Template_Generic'){
            setTemplateFields(['background_image','title_font_color','subtitle_font_color','close_btn_bg_color','close_btn_fg_color','cta_btn_bg_color','cta_btn_font_color','logo_img','logo_main_img','logo_cta_button_icn','title_text','sub_title_text','cta_btn_text','link_url','switch_badge','badge_image']);
        }else if(template==='Template_Ecommerce_Carousel'){
            setTemplateFields(['background_image','title_font_color','subtitle_font_color','close_btn_bg_color','close_btn_fg_color','product_desc_bg_color','product_desc_font_color','cta_btn_bg_color','cta_btn_font_color','carousel_bg_color','logo_img','logo_cta_button_icn','title_text','sub_title_text','product_item','cta_btn_text']); 
        }else if(template==='Template_Akedo_Packshot'){
            setTemplateFields(['background_image','title_font_color','subtitle_font_color','close_btn_bg_color','close_btn_fg_color','cta_btn_bg_color','cta_btn_font_color','logo_img','logo_main_img','logo_cta_button_icn','title_text','sub_title_text','cta_btn_text','link_url','switch_badge','badge_image']);
        }else if(template==='Template_Akedo_Game'){
            setTemplateFields(['background_image','title_font_color','subtitle_font_color','close_btn_bg_color','close_btn_fg_color','cta_btn_bg_color','cta_btn_font_color','logo_img','logo_main_img','logo_cta_button_icn','title_text','game_name','link_url','switch_badge','badge_image']);
        }
    }

    return (
        <>
            <Row className="d-flex justify-content-center mt-3"><Row><h3 className="module_title">HTML5 Banner Generator</h3></Row></Row>
            {screenType && screenType ==='template_selection' && 
                (
                    <Card style={{ marginBottom: "24px" }}>
                        <Card.Body>
                                <Row style={{display:'flex',textAlign:'center',justifyContent:'space-around'}}>
                                    <Col lg={3} >
                                        <img src={Template_Generic} alt="Generic Template" height={300} width={200} />
                                        <h6>Generic Full Screen</h6>
                                        <input
                                            type="radio"
                                            name="site_name"
                                            value={templateType}
                                            checked={templateType === 'Template_Generic'}
                                            onChange={()=>handleTemplateSelectionChange('Template_Generic')}
                                        />
                                    </Col>
                                    <Col  lg={3}>
                                        <img src={Template_Ecommerce_Carousel} alt="Generic Template" height={300} width={200} />
                                        <h6>E-commerce Carousel</h6>
                                        <input
                                            type="radio"
                                            name="site_name"
                                            value={templateType}
                                            checked={templateType === 'Template_Ecommerce_Carousel'}
                                            onChange={()=>handleTemplateSelectionChange('Template_Ecommerce_Carousel')}
                                        />
                                    </Col>
                                    <Col  lg={3}>
                                        <img src={Template_Akedo_Packshot} alt="Generic Template" height={300} width={200} />
                                        <h6>E-commerce Packshot</h6>
                                        <input
                                            type="radio"
                                            name="site_name"
                                            value={templateType}
                                            checked={templateType === 'Template_Akedo_Packshot'}
                                            onChange={()=>handleTemplateSelectionChange('Template_Akedo_Packshot')}
                                        />
                                    </Col>
                                    <Col lg={3} >
                                        <img src={Template_Akedo_Game} alt="Generic Template" height={300} width={200} />
                                        <h6>Akedo Game</h6>
                                        <input
                                            type="radio"
                                            name="site_name"
                                            value={templateType}
                                            checked={templateType === 'Template_Akedo_Game'}
                                            onChange={()=>handleTemplateSelectionChange('Template_Akedo_Game')}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <Button className="noMargin" variant="primary" disabled={templateType?false:true} onClick={()=>setScreenType('template_design')} > Continue </Button>
                                    </Col>
                                </Row>
                        </Card.Body>
                    </Card>
                )
            } 

            {screenType && screenType ==='template_design' && <TemplateDesignForm templateType={templateType} templateFields={templateFields} />}
        </>
    );
};

export default Html5Generator;
